module.exports = __webpack_public_path__ + "img/2.9cb5ab96.jpg";